// extracted by mini-css-extract-plugin
export default {"summaryContainer":"TradeRowHeader_summaryContainer__EN+p-","headingColumn":"TradeRowHeader_headingColumn__f7io8"};